export const getChartTheme = (theme) => {
  const dark = theme === 'dark';
  return {
    grid: dark ? '#27272a' : '#e4e4e7',
    tick: dark ? '#a1a1aa' : '#71717a',
    tooltipBg: dark ? '#18181b' : '#ffffff',
    tooltipBorder: dark ? '#3f3f46' : '#d4d4d8',
    tooltipColor: dark ? '#fafafa' : '#18181b',
    mapGrid: dark ? '#3f3f46' : '#d4d4d8',
  };
};
